const BaseUrl = '/service/';
const Title = 'IACAS GAPURA';
const WsUrl = 'wss://tpsgapura.mail2typeb.com/ws'
const BaseColor = '#118B50';

module.exports = {
    BaseUrl,
    Title,
    WsUrl,
    BaseColor
}
